import { useSearchDictionary } from 'components/helpers/AlgoliaSearch/util';
import { Dispatch, SetStateAction, useCallback } from 'react';
import { useRefinementList } from 'react-instantsearch-hooks-web';
import { classnames } from 'tailwindcss-classnames';

const FacetTypeAdult = 'Adult';
const FacetTypePediatric = 'Pediatric';
const FacetTypeBoth = 'Pediatric/Adult';

const programList = [FacetTypeAdult, FacetTypePediatric, FacetTypeBoth];

const ProgramTypeFacet = ({
  type,
  setType,
}: {
  type: string;
  setType: Dispatch<SetStateAction<string>>;
}) => {
  const dict = useSearchDictionary();
  const { refine: refineFacets, items: refinedFacets } = useRefinementList({
    attribute: 'programType',
  });
  const handleTypeSelect = useCallback(
    (programType: string) => {
      refinedFacets.forEach((facet) => {
        let shouldRefine: boolean;
        if (facet.value === FacetTypeBoth) {
          // if this facet matches the magic both facet then it should always be active unless
          // no program filter is applied, because...well, I don't know
          shouldRefine = !!programType;
        } else {
          shouldRefine = facet.value === programType || facet.value === FacetTypeBoth;
        }
        if (shouldRefine !== facet.isRefined) {
          refineFacets(facet.value);
        }
      });
      setType(programType);
    },
    [refinedFacets, refineFacets, setType]
  );
  return (
    <div className={classnames('my-4', 'relative', 'md:mr-10', 'md:basis-2/12')}>
      <div className={classnames('text-solidBlack', 'text-base', 'font-semibold', 'mb-0.5')}>
        {dict.programType}
      </div>
      <select
        className={classnames(
          'border',
          'border-gray-spunPearl',
          'focus:outline-none',
          'rounded-md',
          'p-[9px]',
          'w-full'
        )}
        aria-label="Program Type"
        value={type}
        onChange={(e) => handleTypeSelect(e.currentTarget.value)}
      >
        <option
          key="select"
          value=""
          className={classnames('cursor-pointer', 'hover:text-white', 'hover:bg-blue', 'p-1')}
        >
          Select
        </option>
        {programList.map((x) => (
          <option
            key={x}
            value={x}
            className={classnames('cursor-pointer', 'hover:text-white', 'hover:bg-blue', 'p-1')}
          >
            {x === FacetTypeBoth ? 'Pediatric and Adult' : x}
          </option>
        ))}
      </select>
    </div>
  );
};

export default ProgramTypeFacet;
